// Configuração das URLs da API
// Detectar se estamos em desenvolvimento (localhost) ou produção (domínio real)
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// URL da API baseada no ambiente - RENDER APENAS
const API_BASE_URL = isLocalhost 
  ? (() => {
      const useHttps = process.env.REACT_APP_USE_HTTPS === 'true';
      const protocol = useHttps ? 'https' : 'http';
      const port = useHttps ? '5443' : '5000';
      return `${protocol}://localhost:${port}`;
    })()
  : window.location.origin; // Usar mesmo domínio do Render

export { API_BASE_URL };

export const API_ENDPOINTS = {
  // Autenticação
  LOGIN: `${API_BASE_URL}/api/login`,
  REGISTER: `${API_BASE_URL}/api/register`,
  PROFILE: `${API_BASE_URL}/api/profile`,
  REFRESH_TOKEN: `${API_BASE_URL}/api/refresh-token`,
  
  // Produtos
  PRODUCTS: `${API_BASE_URL}/api/products`,
  CATEGORIES: `${API_BASE_URL}/api/categories`,
  
  // Compras
  CHECKOUT: `${API_BASE_URL}/api/finalizar-compra`,
  GUEST_CHECKOUT: `${API_BASE_URL}/api/guest-checkout`,
  
  // Pedidos
  ORDERS: `${API_BASE_URL}/api/orders`,
  ADMIN_ORDERS: `${API_BASE_URL}/api/admin/orders`,
  
  // Imagens
  IMAGES: `${API_BASE_URL}/api/images`,
  UPLOAD_IMAGE: `${API_BASE_URL}/api/upload-image`,
  
  // Slider Home
  HOME_SLIDER: `${API_BASE_URL}/api/home-slider`,
  ADMIN_HOME_SLIDER: `${API_BASE_URL}/api/admin/home-slider`,
  
  // Orçamentos
  SIMPLE_QUOTE: `${API_BASE_URL}/api/simple-quote`,
  ADVANCED_QUOTE: `${API_BASE_URL}/api/advanced-quote`,
  QUOTES: `${API_BASE_URL}/api/quotes`,
  
  // Função para endpoints dinâmicos de imagens de produtos
  PRODUCT_IMAGES: (productId) => `${API_BASE_URL}/api/products/${productId}/images`,
  PRODUCT_IMAGE: (productId, imageId) => `${API_BASE_URL}/api/products/${productId}/images/${imageId}`,
};

// Configuração para requisições fetch
export const getFetchConfig = (method = 'GET', body = null, includeAuth = true) => {
  const config = {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  if (includeAuth) {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  if (body) {
    config.body = JSON.stringify(body);
  }

  return config;
};

// Função auxiliar para fazer requisições à API
export const apiRequest = async (url, options = {}) => {
  try {
    const response = await fetch(url, options);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || 'Erro na requisição');
    }
    
    return data;
  } catch (error) {
    console.error('Erro na API:', error);
    throw error;
  }
};

export default API_BASE_URL;
